import { render } from "./AgreementCard.vue?vue&type=template&id=36cd7de2&scoped=true&ts=true"
import script from "./AgreementCard.vue?vue&type=script&lang=ts"
export * from "./AgreementCard.vue?vue&type=script&lang=ts"

import "./AgreementCard.vue?vue&type=style&index=0&id=36cd7de2&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cd7de2"]])

export default __exports__